// assets
import { ReactComponent as InterviewIcon } from "../assets/images/icons/InterviewIcon.svg";
import { DashboardOutlined } from "@ant-design/icons";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import CoPresentOutlinedIcon from "@mui/icons-material/CoPresentOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import CelebrationIcon from "@mui/icons-material/Celebration";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { ReactComponent as TechnicalEmployeeIcon } from "assets/images/icons/techical_employee.svg";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import BrandOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ItemsOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import AnnoucementOutlinedIcon from "@mui/icons-material/CampaignOutlined";
// import ListAltIcon from '@mui/icons-material/ListAlt';
import MenuIcon from "@mui/icons-material/Menu";
import TaskIcon from '@mui/icons-material/Task';
import TodayIcon from "@mui/icons-material/Today";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TryOutlinedIcon from "@mui/icons-material/TryOutlined";
import HttpsIcon from "@mui/icons-material/Https";
import ManageHistorySharpIcon from "@mui/icons-material/ManageHistorySharp";
import HistoryIcon from '@mui/icons-material/History';
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";
import EventNoteIcon from '@mui/icons-material/EventNote';


const icons = {
  ViewKanbanOutlinedIcon,
  EventNoteIcon,
  DashboardOutlined,
  DashboardOutlinedIcon,
  FactCheckOutlinedIcon,
  Diversity3OutlinedIcon,
  PeopleOutlineOutlinedIcon,
  CoPresentOutlinedIcon,
  LocalShippingOutlinedIcon,
  CurrencyExchangeOutlinedIcon,
  CelebrationIcon,
  EventAvailableIcon,
  TechnicalEmployeeIcon,
  SettingsOutlinedIcon,
  BrandOutlinedIcon,
  ItemsOutlinedIcon,
  AnnoucementOutlinedIcon,
  // ListAltIcon,
  TryOutlinedIcon,
  MenuIcon,
  TaskIcon,
  TodayIcon,
  interviewIcon: <InterviewIcon />,
  HttpsIcon,
  ManageHistorySharpIcon,
  HistoryIcon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const employee = {
  id: "group-dashboard",
  title: "Navigation",
  type: "admin",
  children: [
    {
      id: "emplyoee-details",
      title: "Employees",
      type: "is_access_to_employee",
      url: "/emplyoee",
      icon: icons.PeopleOutlineOutlinedIcon,
    },
    {
      id: "technical-employee-view",
      title: "Technical Employees",
      type: "is_techinal_employee_view",
      url: "/technical-employee",
      icon: icons.TechnicalEmployeeIcon,
    },
    {
      id: "roles",
      title: "Roles",
      type: "is_access_to_roles",
      url: "/roles",
      icon: icons.CoPresentOutlinedIcon,
    },
    {
      id: "departments",
      title: "Departments",
      type: "is_access_to_department",
      url: "/departments",
      icon: icons.Diversity3OutlinedIcon,
    },
    {
      id: "project",
      title: "All Projects",
      type: "is_access_to_project",
      url: "/project",
      icon: icons.MenuIcon,
    },
    // {
    //   id: "pms",
    //   title: "PMS",
    //   type: "is_access_to_project",
    //   icon: icons.ViewKanbanOutlinedIcon,
    // },
    // {
    //   id: "tasks",
    //   title: "Projects Tasks",
    //   type: "is_access_to_project",
    //   url: "/boards",
    //   icon: icons.TaskIcon,
    // },
    // {
    //   id: "general_attendance",
    //   title: "General Attendance",
    //   url: "/general-attendance",
    //   icon: icons.EventAvailableIcon,
    // },
    // {
    //   id: "supplier",
    //   title: "Supplier",
    //   url: "/supplier",
    //   icon: icons.LocalShippingOutlinedIcon,
    // },
    // {
    //   id:"brand",
    //   title : "Brand",
    //   url : "/brand",
    //   icon : icons.BrandOutlinedIcon
    // },
    // {
    //   id:"items",
    //   title : "Items",
    //   url : "/items",
    //   icon : icons.ItemsOutlinedIcon
    // },
    {
      id: "assets",
      title: "Assets",
      url: "/assets",
      icon: icons.CurrencyExchangeOutlinedIcon,
    },
    {
      id: "leave_request_details",
      title: "Leave Request Details",
      url: "/leave-request-details",
      icon: CalendarMonthIcon,
    },
    {
      id: "time_log_viewer",
      title: "Time Log Viewer",
      url: "/time-log-viewer",
      type: "is_admin_role",
      icon: ManageHistorySharpIcon,
    },
    {
      id: "setting",
      title: "Settings",
      url: "/setting",
      icon: icons.SettingsOutlinedIcon,
      children: [
        {
          id: "general_attendance",
          title: "General Attendance",
          url: "/general-attendance",
          icon: icons.EventAvailableIcon,
        },
        {
          id: "holidays",
          title: "Holidays",
          url: "/holidays",
          icon: icons.TodayIcon,
        },
        {
          id: "announcements",
          title: "Announcements",
          url: "/announcements",
          icon: icons.AnnoucementOutlinedIcon,
        },
        {
          id: "party",
          title: "Party",
          url: "/party",
          icon: icons.CelebrationIcon,
        },
        {
          id: "feedback",
          title: "Feedback",
          url: "/feedback",
          icon: icons.TryOutlinedIcon,
        },
      ],
    },
    {
      id: "leave_balance",
      title: "Leave Balance",
      url: "/leave-balance",
      icon: icons.EventAvailableIcon,
    },
    {
      id: "interview",
      title: "Interviews",
      url: "/interview",
      icon: icons.interviewIcon,
    },
    {
      id: "credential",
      title: "Credentials",
      type: "item",
      url: "/credential",
      icon: icons.HttpsIcon,
    },
    // {
    //   id: "party",
    //   title: "Party",
    //   url: "/party",
    //   icon: icons.CelebrationIcon,
    // },
    {
      id: "activity",
      title: "Activity",
      type: "item",
      url: "/user-logs",
      icon: icons.HistoryIcon,
    },
  ],
};

export default employee;
